



























import {Vue, Component, Prop, Mixins} from "vue-property-decorator";
import FormGroup from "@/components/ui/forms/FormGroup.vue";
import {ITestimonial, ITestimonialLinkDTO, ITestimonialDTO, TestimonialService} from "./../services/testimonial.service";
import {HashMap} from "./../services/base.service";
import NotificationMixin from "./../mixins/NotificationMixin";


@Component({
    name: "TestimonialLinkForm",
    components: {
        FormGroup,
    }
})
export default class TestimonialForm extends Mixins(NotificationMixin) {

    public initialized = false;
    private submission!: ITestimonialLinkDTO;
    private service!: TestimonialService;

    private errors: HashMap<string> = {};

    private submitted = false;

    private rating: number = 0;
    private name: string = "";

    private clear() {
        this.submission = {
            companyName: "",
            name: "",
            email: "",
            anonymous: false,
        }
        this.rating = 0;
        this.errors = {};
    }

    private async created() {
        this.initialized = false;
        this.service = new TestimonialService();
    
        this.clear();
    
        this.initialized = true;
    }

    private async submit() {
        const response = await this.service.post(this.submission);
        if (response.success) {
            this.notifySuccess("Created testimonial");
            this.$emit('create');
            this.clear();
        } else {
            this.notifyError("Failed to create testimonial, check errors");
            this.errors = response.error;
        }
    }
}

